// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add all variables here */
:host {
  position: relative;
}

:host {
  --header-mobile-gap: 12px;
}

.header-middle {
  margin-top: 22px;
  margin-bottom: 22px;
  font-weight: 400;
}
.header-middle a:hover {
  text-decoration: underline;
}
.header-middle .header-icons {
  color: white;
  font-size: 12px;
  line-height: 16px;
}
.header-middle .link-erhverv {
  text-align: center;
}
.header-middle .link-erhverv p {
  color: white;
}
.header-middle .link-delivery-check {
  text-align: center;
}
.header-middle .link-delivery-check p {
  color: white;
}
.header-middle .link-dagens-vin {
  text-align: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.header-middle .link-dagens-vin p {
  color: white;
}
.header-middle .link-dagens-vin app-menu-announcekit {
  position: absolute;
  top: -6px;
  right: -10px;
  width: 22px;
  height: 22px;
}
.header-middle .link-dagens-vin app-menu-announcekit ::ng-deep announcekit {
  width: 22px;
  height: 22px;
}
.header-middle .lower-item {
  text-align: center;
}

.logo-link {
  display: block;
}

.header-quicksearch {
  position: static;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.header-quicksearch__inner {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.header-quicksearch__search {
  display: block;
  flex: 1 1 auto;
  min-width: 0;
}

.header-Logo {
  padding-right: 0;
}

.header-box {
  display: flex;
  align-items: center;
  gap: clamp(34px, 3vw, 52px);
}

.header-Cart {
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-check-box {
  position: absolute;
  right: -8px;
  top: 10px;
  display: flex;
  background-color: #00900E;
  color: white;
  border-radius: 30px;
  width: 15px;
  height: 15px;
  align-items: center;
  justify-content: center;
}
.login-check-box ::ng-deep svg {
  width: 10px;
  height: 8px;
}

.header-links {
  display: flex;
  align-items: center;
  gap: 10px;
}

.burger-menu {
  display: flex;
  align-items: center;
  justify-content: center;
  appearance: none;
  border: 0;
  background: transparent;
  color: white;
  padding: 0;
  flex: 0 0 auto;
}
.burger-menu ::ng-deep svg {
  width: 26px;
  height: 30px;
}

app-header-middle-voucher, .user-login {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.user-hello {
  max-width: 80px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.mobile-menu {
  font-size: 28px;
  padding: 0 4px;
  margin-left: 12px;
}

@media (min-width: 992px) {
  #show-content-mobile {
    display: none;
  }
  .header-Logo {
    order: 1;
    flex: 0 0 auto;
    width: auto;
  }
  .header-quicksearch {
    order: 2;
    flex: 1 1 0;
    min-width: 0;
    padding-left: 0;
    padding-right: 0;
  }
  .header-middle .header-icons {
    order: 3;
    display: flex;
    align-items: center;
    gap: 20px;
    flex: 0 0 auto;
  }
  .header-Cart {
    order: 4;
    padding-left: 0;
  }
  .header-links {
    justify-content: flex-start;
    gap: 20px;
  }
}
@media (max-width: 991.98px) {
  :host {
    --header-mobile-gap: 14px;
  }
  .header-box {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    row-gap: 10px;
  }
  .header-Logo {
    order: 1;
    width: 126px;
    flex: 0 0 auto;
  }
  .header-quicksearch {
    order: 3;
    margin-top: 0;
    padding-left: 0;
    padding-right: 0;
    flex: 1 0 100%;
  }
  .header-quicksearch__inner {
    gap: var(--header-mobile-gap);
  }
  .header-quicksearch__search {
    min-width: 0;
  }
  .header-middle {
    margin: 8px 8px 12px;
  }
  .header-middle .header-icons {
    order: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1 1 auto;
  }
  .header-links {
    justify-content: flex-start;
    gap: var(--header-mobile-gap);
    flex-wrap: nowrap;
  }
  .header-Cart {
    order: 2;
    flex: 0 0 auto;
    padding-left: 0;
  }
  .burger-menu {
    width: 32px;
    height: 32px;
  }
  .login-check-box {
    top: 8px;
    right: -4px;
  }
}
app-trustpilot {
  height: 37px;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/variables.scss","webpack://./src/app/content/layout/components/general/header/components/header-middle/header-middle.component.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss"],"names":[],"mappings":"AAAA,2BAAA;ACGA;EACE,kBAAA;AADF;;AAIA;EACE,yBAAA;AADF;;AAIA;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;AADF;AAGE;EACE,0BAAA;AADJ;AAIE;EACE,YAAA;EACA,eAAA;EACA,iBAAA;AAFJ;AAKE;EACE,kBAAA;AAHJ;AAKI;EACE,YAAA;AAHN;AAOE;EACE,kBAAA;AALJ;AAOI;EACE,YAAA;AALN;AASE;EACE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAPJ;AASI;EACE,YAAA;AAPN;AAUI;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AARN;AAUM;EACE,WAAA;EACA,YAAA;AARR;AAaE;EACE,kBAAA;AAXJ;;AAeA;EACE,cAAA;AAZF;;AAeA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAZF;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AAZF;;AAeA;EACE,cAAA;EACA,cAAA;EACA,YAAA;AAZF;;AAeA;EACE,gBAAA;AAZF;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;AAZF;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAZF;;AAeA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AAZF;AAcE;EACE,WAAA;EACA,WAAA;AAZJ;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,SAAA;EACA,uBAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;AAbF;AAeE;EACE,WAAA;EACA,YAAA;AAbJ;;AAiBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AAdF;;AAiBA;EACE,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AAdF;;AC9FI;EDgHF;IACE,aAAA;EAdF;EAiBA;IACE,QAAA;IACA,cAAA;IACA,WAAA;EAfF;EAkBA;IACE,QAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;EAhBF;EAmBA;IACE,QAAA;IACA,aAAA;IACA,mBAAA;IACA,SAAA;IACA,cAAA;EAjBF;EAoBA;IACE,QAAA;IACA,eAAA;EAlBF;EAqBA;IACE,2BAAA;IACA,SAAA;EAnBF;AACF;AClHI;EDyIF;IACE,yBAAA;EApBF;EAuBA;IACE,aAAA;IACA,eAAA;IACA,mBAAA;IACA,8BAAA;IACA,aAAA;EArBF;EAwBA;IACE,QAAA;IACA,YAAA;IACA,cAAA;EAtBF;EAyBA;IACE,QAAA;IACA,aAAA;IACA,eAAA;IACA,gBAAA;IACA,cAAA;EAvBF;EA0BA;IACE,6BAAA;EAxBF;EA2BA;IACE,YAAA;EAzBF;EA4BA;IACE,oBAAA;EA1BF;EA4BE;IACE,QAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,cAAA;EA1BJ;EA8BA;IACE,2BAAA;IACA,6BAAA;IACA,iBAAA;EA5BF;EA+BA;IACE,QAAA;IACA,cAAA;IACA,eAAA;EA7BF;EAgCA;IACE,WAAA;IACA,YAAA;EA9BF;EAiCA;IACE,QAAA;IACA,WAAA;EA/BF;AACF;AAkCA;EACE,YAAA;EACA,cAAA;AAhCF","sourcesContent":["/* Add all variables here */\n\n@import \"bootstrap/scss/functions\";\n@import \"bootstrap/scss/variables\";\n\n$text-orange: #F7941E;\n$wine-red-light: #5c0a31;\n$wine-red-dark: #3d051f;\n$wine-text-color: #37041c;\n$light-grey: #efefef;\n$yellow-cta: #ff9812;\n$gold: #e0b55d;\n$color-cloud-grey: #F9F9F9;\n$color-grey: #d5d5d5;\n$color-almost-black: #212529;\n$stock-green: #60E040;\n\n$supervin-color-bordeaux: #3E0523;\n\n$color-charcoal-black: #000;\n$theme-colors: (\n  \"primary\": $yellow-cta,\n  \"secondary\": $secondary,\n  \"success\": $yellow-cta, //$success,\n  \"info\": $yellow-cta, //$info,\n  \"warning\": $warning,\n  \"danger\": $danger,\n  \"light\": $light,\n  \"dark\": $dark\n);\n\n$container-max-widths: (\n  xl: 1280px\n);\n\n$header-height: 100px;\n\n$border-divider: 1px solid $color-cloud-grey;\n$breadcrumb-height: 30px;\n\n@mixin supervin-box-shadow {\n  box-shadow: 1px 1px 5px 0 rgba(0,0,0,0.4);\n}\n\n@mixin btn-primary {\n\n  border-radius: 0;\n  text-transform: uppercase;\n  padding: 0.7rem 1.3rem;\n  font-size: 0.8rem;\n  background-color: $yellow-cta;\n  border: solid 1px $yellow-cta;\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  line-height: 1.5;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n\n\n\n","@import \"src/variables\";\n@import \"bootstrap/scss/mixins/breakpoints\";\n\n:host {\n  position: relative;\n}\n\n:host {\n  --header-mobile-gap: 12px;\n}\n\n.header-middle {\n  margin-top: 22px;\n  margin-bottom: 22px;\n  font-weight: 400;\n\n  a:hover {\n    text-decoration: underline;\n  }\n\n  .header-icons {\n    color: white;\n    font-size: 12px;\n    line-height: 16px;\n  }\n\n  .link-erhverv {\n    text-align: center;\n\n    p {\n      color: white;\n    }\n  }\n\n  .link-delivery-check {\n    text-align: center;\n\n    p {\n      color: white;\n    }\n  }\n\n  .link-dagens-vin {\n    text-align: center;\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    p {\n      color: white;\n    }\n\n    app-menu-announcekit {\n      position: absolute;\n      top: -6px;\n      right: -10px;\n      width: 22px;\n      height: 22px;\n\n      ::ng-deep announcekit {\n        width: 22px;\n        height: 22px;\n      }\n    }\n  }\n\n  .lower-item {\n    text-align: center;\n  }\n}\n\n.logo-link {\n  display: block;\n}\n\n.header-quicksearch {\n  position: static;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.header-quicksearch__inner {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n}\n\n.header-quicksearch__search {\n  display: block;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.header-Logo {\n  padding-right: 0;\n}\n\n.header-box {\n  display: flex;\n  align-items: center;\n  gap: clamp(34px, 3vw, 52px);\n}\n\n.header-Cart {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.login-check-box {\n  position: absolute;\n  right: -8px;\n  top: 10px;\n  display: flex;\n  background-color: #00900E;\n  color: white;\n  border-radius: 30px;\n  width: 15px;\n  height: 15px;\n  align-items: center;\n  justify-content: center;\n\n  ::ng-deep svg {\n    width: 10px;\n    height: 8px;\n  }\n}\n\n.header-links {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.burger-menu {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  appearance: none;\n  border: 0;\n  background: transparent;\n  color: white;\n  padding: 0;\n  flex: 0 0 auto;\n\n  ::ng-deep svg {\n    width: 26px;\n    height: 30px;\n  }\n}\n\napp-header-middle-voucher, .user-login {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n}\n\n.user-hello {\n  max-width: 80px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.mobile-menu {\n  font-size: 28px;\n  padding: 0 4px;\n  margin-left: 12px;\n}\n\n@include media-breakpoint-up(lg) {\n  #show-content-mobile {\n    display: none;\n  }\n\n  .header-Logo {\n    order: 1;\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .header-quicksearch {\n    order: 2;\n    flex: 1 1 0;\n    min-width: 0;\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .header-middle .header-icons {\n    order: 3;\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    flex: 0 0 auto;\n  }\n\n  .header-Cart {\n    order: 4;\n    padding-left: 0;\n  }\n\n  .header-links {\n    justify-content: flex-start;\n    gap: 20px;\n  }\n}\n\n@include media-breakpoint-down(lg) {\n  :host {\n    --header-mobile-gap: 14px;\n  }\n\n  .header-box {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    row-gap: 10px;\n  }\n\n  .header-Logo {\n    order: 1;\n    width: 126px;\n    flex: 0 0 auto;\n  }\n\n  .header-quicksearch {\n    order: 3;\n    margin-top: 0;\n    padding-left: 0;\n    padding-right: 0;\n    flex: 1 0 100%;\n  }\n\n  .header-quicksearch__inner {\n    gap: var(--header-mobile-gap);\n  }\n\n  .header-quicksearch__search {\n    min-width: 0;\n  }\n\n  .header-middle {\n    margin: 8px 8px 12px;\n\n    .header-icons {\n      order: 2;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex: 1 1 auto;\n    }\n  }\n\n  .header-links {\n    justify-content: flex-start;\n    gap: var(--header-mobile-gap);\n    flex-wrap: nowrap;\n  }\n\n  .header-Cart {\n    order: 2;\n    flex: 0 0 auto;\n    padding-left: 0;\n  }\n\n  .burger-menu {\n    width: 32px;\n    height: 32px;\n  }\n\n  .login-check-box {\n    top: 8px;\n    right: -4px;\n  }\n}\n\napp-trustpilot {\n  height: 37px;\n  display: block;\n}\n\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
